<template>
  <div>
    <damage-assessment-form
                            :images="images"
                            :insurers="insurers"
                            :estimate-id="estimateId"
                            :assessmentAi="assessmentAi"
                            :isHasAssessment="assessmentAi?.damage"
                            :form-data="formData"
                            :defaultValues="defaultValues"
                            @rerun-assessment="$emit('rerun-assessment')"
                            @del-assessment="$emit('del-assessment')"
                            @add-parts="val=>$emit('add-parts',val)"
                            @update-vehicle="$emit('update-vehicle')"
                            @reload-estimate="$emit('reload-estimate')"
    ></damage-assessment-form>

  </div>
</template>

<script>

import DamageAssessmentForm from "./damage-assessment/damage-assessment-form.vue";
import ItemList from "@/components/estimates/estimate-edit/item-list.vue";

export default{
  name: "damage-assessment",
  components: {ItemList, DamageAssessmentForm},
  props: {
    assessmentAi: {
      type: [Object,null],
      default:()=>{}
    },
    images: {
      type: Array,
      default () {
        return {}
      }
    },
    insurers:{
      type: Array,
      default () {
        return {}
      }
    },
    defaultValues:{
      type:Object,
      default: () => ({})
    },
    estimateId: 0,
    formData: {
      type: Object,
      default: () => ({})
    }
  },
}
</script>

<style scoped>

</style>
